import { Box } from '@mui/material'
import React from 'react'
import Header from 'components/Header'
import InvoicesTable from 'components/InvoicesTable'
import update from 'immutability-helper'
import { InvoiceSearchForm } from 'types/interfaces'

const AdminInvoiceList: React.FC = () => {
  const [invoiceSearchForm, setInvoiceSearchForm] = React.useState<InvoiceSearchForm>({})
  
  const updateInvoiceSearchForm = React.useCallback((name: string, value: any) => {
    setInvoiceSearchForm(update(invoiceSearchForm, { [name]: { $set: value } }))
  }, [invoiceSearchForm])
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100%' }}>
      <Header text='Invoice List'></Header>
      <InvoicesTable 
        isAdmin={true} 
        form={invoiceSearchForm} 
        updateForm={updateInvoiceSearchForm} 
        setForm={setInvoiceSearchForm}
      />
    </Box>
  )
}

export default AdminInvoiceList